import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Check Box icon. Exported from Figma (Bombiix 2026). */
const CheckBoxIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="white" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="#A4A4A4" />
    <g>
      <path
        d="M4.17383 10.684C5.8567 12.3605 7.54549 14.002 7.54549 14.002C7.54549 14.002 13.2398 8.71305 15.7965 6.03747C15.8077 6.02563 15.8189 6.01379 15.8296 6.00195"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default CheckBoxIcon;
